<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	//Stores
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Alert, Button, Input } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getErrorOrInfoMessageForMinAndMax } from 'src/helpers/utilities';

	export let device;

	let id = real_id(device.id);
	const min = 0;
	const max = 100;

	let settings = readDeviceSettings(id);

	let minBrightness =
		settings[get_gen_2_component_channel_structure(device)]?.min_brightness_on_toggle;

	let cacheMinBrightness = minBrightness;

	let loading = false;

	$: inputData = getErrorOrInfoMessageForMinAndMax(minBrightness, min, max);

	const setMinBrightness = async () => {
		if (cacheMinBrightness === minBrightness || inputData.error) return;
		loading = true;

		const params = {
			id: device.channel,
			config: {
				min_brightness_on_toggle: minBrightness,
			},
		};

		const res: SettingRequest = await gen2Request(
			device,
			`${get_gen_2_component_from_category(device)}.SetConfig`,
			params,
		);
		const response = onSettingsResponse(res, device);
		if (response) {
			settings[`${get_gen_2_component_channel_structure(device)}`].min_brightness_on_toggle =
				minBrightness;
			devices_settings.update_devices_settings(id, settings);
			cacheMinBrightness = minBrightness;
		} else {
			minBrightness = cacheMinBrightness;
		}
		loading = false;
	};
</script>

<Alert
	class="mb-s"
	heading={$format('alert_heading_min_brightness_on_toggle', {
		default: `Brightness level (in percent) applied when there is a toggle and current brightness is lower than 'Min brightness on toggle'.`,
	})}
/>
<Input
	class="mb-s"
	size="m"
	bind:value={minBrightness}
	error={inputData.error}
	info={inputData.info}
	type={'number'}
	{min}
	{max}
	step={1}
	on:enter={setMinBrightness}
	id="input-2qb5jcc"
	aria-label={$format('alert_heading_min_brightness_on_toggle', {
		default: `Brightness level (in percent) applied when there is a toggle and current brightness is lower than 'Min brightness on toggle'.`,
	})}
/>
<Button {loading} size="m" width="full" on:click={setMinBrightness}>
	{$format('button_save')}
</Button>
<!-- <Slider
	class="mb-s"
	type="horizontal"
	bind:value={minBrightness}
	{min}
	{max}
	unit="%"
	on:value_change={setMinBrightness}
/> -->
